/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_ParticipantTask_OptionElectHangfireDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_OptionElectHangfireDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_RsuElectHangfireDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_RsuElectHangfireDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ElectService {

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppElectElectPendingAwards(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/elect/elect-pending-awards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppElectAccelerateAwards(): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/elect/accelerate-awards',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppElectElectPendingAwardsByVestingDateId(
requestBody?: Array<Wealthlane_AwardService_Dtos_ParticipantTask_RsuElectHangfireDto>,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/elect/elect-pending-awards-by-vesting-date-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppElectElectPendingOptionAwardsByVestingDateId(
requestBody?: Array<Wealthlane_AwardService_Dtos_ParticipantTask_OptionElectHangfireDto>,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/elect/elect-pending-option-awards-by-vesting-date-id',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
